import { render, staticRenderFns } from "./RecentMagazinesSection.vue?vue&type=template&id=fe00dc8a&scoped=true&"
import script from "./RecentMagazinesSection.vue?vue&type=script&lang=js&"
export * from "./RecentMagazinesSection.vue?vue&type=script&lang=js&"
import style0 from "./RecentMagazinesSection.vue?vue&type=style&index=0&id=fe00dc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe00dc8a",
  null
  
)

export default component.exports